<template>
  <div
    class="modal fade"
    v-bind:id="'ModalAddNewTabagheBandiAmaliyati-' + getParentCode"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ثبت طبقه بندی عملیاتی جدید</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 100%; overflow: auto">

          <p class="h6 mt-2 text-info">{{this.getTitel1}}</p>
          <p v-if="this.getTitel2 != ''" class="h7 mb-2 text-info">{{this.getTitel2}}</p>

          <div class="row">
            <!-- کادر کد طبقه بندی -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="کد طبقه بندی"
                class="form-control text-center"
                v-model="NewTabagheBandiAmaliyati.SPerNationalId"
                autocomplete="off"
                style="direction: ltr"
                maxlength="1"
                v-bind:disabled="getParentCode != 0"
              />
              <i
                class="
                  fas
                  fa-qrcode fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="کد طبقه بندی"
                style="top: 10%"
              ></i>
            </div>

            <!-- کادر عنوان طبقه بندی -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="عنوان طبقه بندی"
                class="form-control text-center"
                v-model="NewTabagheBandiAmaliyati.NPerLastName"
                autocomplete="off"
                maxlength="250"
                id="inputNPerLastName"
              />
              <i
                title="عنوان طبقه بندی"
                class="
                  fas
                  fa-edit fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                style="top: 10%"
              ></i>
            </div>

          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center justify-content-between px-4" style="height: 15%">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="SaveNewBaseAcc()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ثبت {{NPerName}} جدید
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalAddNewTabagheBandiAmaliyati',
  props: ['ParentCode','Title1', 'Title2','NewChildCode','NPerType','NPerName'],
  data() {
    return {
      // اطلاعات طبقه بندی عملیاتی جدید
      NewTabagheBandiAmaliyati: {
        NUserCode: 1, // کد کاربر مدیر
        NPerID: 0, // کد یکتا سطر
        SPerNationalId: 0, //  کد طبقه بندی علمیاتی
        NPerTaxNu: '', // خالی
        NPerNationalType: 1, // 1
        NPerType: 4, // کد نوع : 4 ماموریت - 5 برنامه - 6 طرح - 7 خدمت - 8 پروژه
        NPerTaxType: 5, // 5
        NPerName: 'ماموریت', // نام نوع : ماموریت - برنامه - طرح - خدمت - پروژه
        NPerLastName: '', // عنوان طبقه بندی عملیاتی
        NPerProvinceCode: 10, // کد استان
        NPerCityCode: 1001000, // کد شهر
        NPerAddress: '', // خالی
        NPerTelCode: '', // خالی
        NPerTel: '', // خالی
        NPerPostcalCode: '', // خالی
        NPerKalaType: 12, // 12
        SDate: '', // تاریخ ثبت
        DTime: '', // ساعت ثبت
        SJob: '', // خالی
        SShopName: '', // خالی
        SMobileNu: '', // خالی
        SFaxNu: '', // خالی
        SAccNu: '', // خالی
        SAccCardNu: '', // خالی
        SAccIRNu: '', // خالی
        NAccBank: 0, // 0
        NPerFatherName: '', // خالی
        NYear: 0, // سال
        NGroup: 0, // 0
        NPerIDPay: 0, // 0
      },
      // کنترل اتصال به سرور
      checkConnectToServer: false,
    };
  },
  mounted() {
    // رویداد نمایش مودال
    // $('#ModalEditTabagheBandiAmaliyati-' + this.getRowNCode).on('shown.bs.modal', this.getUserData);      
    // رویداد بسته شدن مودال
    $('#ModalAddNewTabagheBandiAmaliyati-' + this.getParentCode).on("hidden.bs.modal", this.HideModal);
  },
  computed: {
    // دریافت کد والد
    getParentCode(){
        return this.ParentCode;
    },
    // دریافت عبارت سربرگ
    getTitel1(){
        this.NewTabagheBandiAmaliyati.SPerNationalId = this.NewChildCode;
        this.NewTabagheBandiAmaliyati.NPerType = this.NPerType;
        this.NewTabagheBandiAmaliyati.NPerName = this.NPerName;
        return this.Title1;
    },
    getTitel2(){
        setTimeout(() => {
            $('#inputNPerLastName').focus();
        }, 500);
        return this.Title2;
    },
  },
  methods: {
    // رویداد بسته شدن مودال
    HideModal(){
      console.log("Close Modal");
      // اعلام اعمال تغییرات به والد
      this.$emit("HideModalAddNewTabagheBandiAmaliyati");
    },
    // ذخیره تغییرات حساب کاربری
    async SaveNewBaseAcc() {
        // آیا کد طبقه بندی مقدار دهی شده است ؟
        if (this.NewTabagheBandiAmaliyati.SPerNationalId != "") {
          // آیا نام طبقه بندی ثبت شده است ؟
          if (this.NewTabagheBandiAmaliyati.NPerLastName != "") {
            // اعلام اتصال به سرور
            this.checkConnectToServer = true;
            // دریافت توکن احراز هویت
            let token = await this.$store.getters.getUserData.token;
            // کد کاربری
            let NUserCode = await this.$store.getters.getUserData.NUserCode;
            // دریافت تاریخ ثبت
            this.NewTabagheBandiAmaliyati.SDate = this.$store.getters.getPersianDateValue.PersianDate;
            // درج ساعت ثبت
            // چون فیلد مورد نظر از نوع
            // DateTime
            //  هست لذا باید فرمت
            // ISO
            // استفاده شود
            this.NewTabagheBandiAmaliyati.DTime = new Date().toISOString();
            // درج کد کاربر جاری
            this.NewTabagheBandiAmaliyati.NUserCode = NUserCode;
            // درج تاریخ جاری
            // this.$store.getters.getPersianDateValue.PersianYear
            this.NewTabagheBandiAmaliyati.NYear = this.$store.getters.getYearActive;
            // درج عنوان نوع طبقه بندی
            this.NewTabagheBandiAmaliyati.NPerType = this.NPerType;
            this.NewTabagheBandiAmaliyati.NPerName = this.NPerName;
            // خالی کردن کد یکتای سطر جهت درج جدید
            this.NewTabagheBandiAmaliyati.NPerID = 0;
            // ثبت طبقه بندی جدید در سرور
            await this.$store.dispatch("SaveNewTabagheBandiAmaliyatiToServer", {
            TabagheBandiAmaliyatiData: this.NewTabagheBandiAmaliyati,
            token: token,
            });
            // بستن مودال ثبت طبقه بندی جدید
            $("#ModalAddNewTabagheBandiAmaliyati-" + this.getParentCode).modal("hide");
          } else {
            // ثبت نام حساب الزامی است
            this.$store.dispatch("notify", {
              notText: "عدم درج نام " + this.NPerName + " : درج نام " + this.NPerName + " الزامی است !",
              timeOut: 2500,
            });
          }
        } else {
          // ثبت کد حساب الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج کد " + this.NPerName + " : درج کد " + this.NPerName + " الزامی است !",
            timeOut: 2500,
          });
        }
        // لغو اعلام اتصال به سرور
        this.checkConnectToServer = false;
    },
  },
};
</script>

<style>
/* استایل آیکون کنار فیلدها */
.iconStyle {
  top: 18%;
  right: 0px;
  border-radius: 50%;
  background-color: #e6f2fd;
  border: 1px solid #ced4da;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* استایل فیلدهای اجباری */
.MandatoryStyle {
  background-color: #fde6e6;
}
/* استایل انتخاب سطر */
.selectStyle {
  font-size: 12px;
  height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListTabagheBandiAmaliyati/Components/AddNewTabagheBandiAmaliyati.vue